
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-path",attrs:{"stroke":"#798f8f","stroke-linejoin":"round","d":"M2.5 6.976a.5.5 0 0 1 .213-.41L8.5 2.5l5.788 4.067a.5.5 0 0 1 .212.409V14a.5.5 0 0 1-.5.5h-3.5v-5h-4v5H3a.5.5 0 0 1-.5-.5z"}})])
          )
        }
      }
    